import { Component, HostListener, Inject, OnInit } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { DEFAULT_DIALOG_CLASS, TUTORIAL_DIALOG_CLASS } from "@merri/common";
import { ArrowClass, TutorialDialogResult, TutorialStepInfo } from "../../models";

@Component({
    selector: "app-tutorial-dialog",
    templateUrl: "./tutorial-dialog.component.html",
    styleUrls: ["./tutorial-dialog.component.scss"],
    standalone: false
})
export class TutorialDialogComponent implements OnInit {
  message: string;
  header: string;
  actionText: string;
  arrowClass: string;
  currentStep: number;
  totalSteps: number;

  constructor(private _dialog: MatDialogRef<any, TutorialDialogResult>, @Inject(MAT_DIALOG_DATA) private info: TutorialStepInfo) {
    this.message = this.info.message;
    this.header = this.info.header;
    this.actionText = this.info.actionText;
    this.arrowClass = this.info.arrowClass ? this.info.arrowClass : ArrowClass.None;
    this.currentStep = this.info.step || 1;
    this.totalSteps = this.info.totalSteps || 0;
  }

  ngOnInit() {
    this._dialog.disableClose = true;
    this._dialog.addPanelClass([DEFAULT_DIALOG_CLASS, TUTORIAL_DIALOG_CLASS]);
  }

  @HostListener("window:keydown.escape", [])
  close() {
    this._dialog.close({ goNext: true });
  }

  skip() {
    this._dialog.close({ goNext: false });
  }
}
